import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { IProvider } from "../../models/providers";
import { ProvidersService } from "../../providers.service";
import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-providers-list",
  templateUrl: "./providers-list.component.html",
  styleUrls: ["./providers-list.component.scss"],
})
export class ProvidersListComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public searchKey: string = null;
  public tableLimit: number = 10;
  public providers: IProvider[] = [];
  public filterProviders: IProvider[] = [];

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private _providerService: ProvidersService,
    private router: Router,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.EXTERNAL_USERS_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.EXTERNAL_USERS_LIST",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_providers")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadProviders();
    this.search();
  }

  async loadProviders(): Promise<any> {
    this.providers = await this._providerService.getList().then((providersList: any) => {
      return providersList.map((provider: any) => {
        if (provider.logo) {
          provider.logo = environment.CDN_URL + "/" + provider.logo;
        }
        return provider;
      });
    });
  }

  search(): void {
    let filteredArray: IProvider[] = this.providers;

    if (this.searchKey && this.searchKey.length > 0) {
      const key: string = this.searchKey.toLowerCase();
      filteredArray = filteredArray.filter((provider: IProvider) => provider.name.toLowerCase().includes(key));
    }
    this.filterProviders = filteredArray;
  }

  updateTableLimit(event: { target: { value: string } }): void {
    this.tableLimit = Number(event.target.value);
  }

  async delete(provider: IProvider) {
    if (!this._authenticationService.hasCapability("delete_provider")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${provider?.name}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._providerService
            .delete(provider.id)
            .then(async () => {
              await this.loadProviders();
              await this.search();
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_PROVIDER" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_PROVIDER" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_PROVIDER" });
      });
  }
}
